import React, { useState, useEffect } from 'react';
import useTrainingPlanStore from '../../stores/trainingPlanStore';
import { useTheme } from '../../context/ThemeContext';

export default function PlanMetaBar() {
 const { themeClasses } = useTheme();
 const meta = useTrainingPlanStore(state => state.meta);
 const updateMeta = useTrainingPlanStore(state => state.updateMeta);
 const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'english');

 useEffect(() => {
 const handleStorageChange = () => setLanguage(localStorage.getItem('language') || 'english');
 window.addEventListener('storage', handleStorageChange);
 window.addEventListener('languageChange', handleStorageChange);
 return () => {
 window.removeEventListener('storage', handleStorageChange);
 window.removeEventListener('languageChange', handleStorageChange);
 };
 }, []);

 const [localDuration, setLocalDuration] = useState('');

 useEffect(() => {
 setLocalDuration(meta.duration_weeks || '');
 }, [meta.duration_weeks]);

 const handleNumberBlur = (field, localValue) => {
 const parsed = parseInt(localValue, 10) || 1;
 if (parsed !== meta[field]) {
 updateMeta({ [field]: parsed });
 }
 };

 const he = language === 'hebrew';
 const repeating = !!meta.is_repeating;

 return (
 <div className="flex flex-col gap-4">
 <div className="grid grid-cols-2 gap-4">
 <div className="space-y-1.5">
 <label className="text-xs font-semibold text-ink-muted uppercase tracking-wider">
 {repeating ? (he ? 'הרצה למשך' : 'Run for') : (he ? 'מספר שבועות' : 'Number of weeks')}
 </label>
 <div className="flex items-center gap-2">
 <input
 type="number"
 min="1"
 max="52"
 value={localDuration}
 onChange={(e) => setLocalDuration(e.target.value)}
 onBlur={() => handleNumberBlur('duration_weeks', localDuration)}
 onKeyDown={(e) => e.key === 'Enter' && e.target.blur()}
 className="w-20 px-3 py-2 rounded-md border bg-canvas dark:bg-canvas-dark text-ink dark:text-ink-dark outline-none focus:ring-2 border-line dark:border-line-dark focus:border-forest focus:ring-forest text-center font-medium"
 />
 <span className="text-sm font-medium text-ink dark:text-ink-dark">{he ? 'שבועות' : 'weeks'}</span>
 </div>
 </div>

 <div className="space-y-1.5">
 <label className="text-xs font-semibold text-ink-muted uppercase tracking-wider">
 {he ? 'חזרה על השבוע' : 'Repeat week'}
 </label>
 <div className="flex items-center h-10">
 <label className="relative inline-flex items-center cursor-pointer">
 <input
 type="checkbox"
 className="sr-only peer"
 checked={repeating}
 onChange={(e) => updateMeta({ is_repeating: e.target.checked })}
 />
          <div className="w-11 h-6 bg-line dark:bg-line-dark peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] rtl:after:right-[2px] rtl:after:left-auto after:bg-surface after:border-line after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-forest"></div>
 <span className="ml-3 rtl:mr-3 rtl:ml-0 text-sm font-medium text-ink dark:text-ink-dark">
 {repeating ? (he ? 'כן' : 'Yes') : (he ? 'לא' : 'No')}
 </span>
 </label>
 </div>
 </div>
 </div>
 <p className="text-xs text-ink-muted leading-snug">
 {repeating
 ? (he
 ? 'שבוע אחד בלוח, שחוזר על עצמו לכל אורך ההרצה. המספר לא מוסיף שבועות.'
 : 'One week on the board, repeated for this many weeks. The number does not add weeks.')
 : (he
 ? 'כל מספר הוא שבוע נפרד בלוח. הפעלת החזרה משאירה שבוע אחד ורצה אותו לכל התקופה.'
 : 'Each number is its own week. Repeat week keeps one week and runs it for the full length.')}
 </p>
 </div>
 );
}